module.exports = __webpack_public_path__ + "static/media/mycraftybleep.853ced02.jpg";